/**
 * 将文件下载到本地
 * @param  {[type]} data     [二进制文件流]
 * @param  {[type]} fileName [创建的下载文件名]
 */
export function dowloadFunc(data, fileName, fileType){
    try {
        let blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
        });
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob);   //创建下载的链接
        // let href = window.URL.createObjectURL(blob);   //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = `${fileName}.${fileType}`;   //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click();    //点击下载
        document.body.removeChild(downloadElement);   //下载完成移除元素
        window.URL.revokeObjectURL(href);   //释放掉blob对象
    } catch (e) {
        console.log(e)
    }

}



// WEBPACK FOOTER //
// ./src/utils/funcs.js